import React from "react";
import Layout from "../compoents/Layout";
import careersData from "../resources/careers";
import AOS from "aos";
import { FaBullhorn } from "react-icons/fa";
AOS.init({
  duration: 1000,
});

function Careers() {
  return (
    <Layout>
      <div className="mt-20">
        <div className="h-screen">
          <div className="h-3/4">
            <lottie-player
              src="https://assets6.lottiefiles.com/packages/lf20_cjkryupy.json"
              background="transparent"
              speed="1"
              loop
              autoplay
            ></lottie-player>
          </div>
          <h1
            className="text-4xl text-center font-bold mt-5 py-5"
            data-aos="slide-up"
          >
            Grab the Oppurtunities
          </h1>
          <hr />
          <p className="text-l font-semibold text-center md:text-justify">
            We are a team of young professionals with dream to succeed in life
            through hard work, commitment and honesty.
          </p>
        </div>
        {/* <div className='font-bold text-center bg-red-500 mx-20 p-20 text-white rounded-tl-full rounded-br-full md:mx-5'>
            <h1 className='text-8xl md:text-3xl' data-aos='slide-left'>THE GAME IS...</h1>
            <h1 className='text-8xl md:text-3xl' data-aos='slide-right'>CONSISTANCY</h1>
        </div> */}
      </div>

      <div className="grid mt-20 md:grid-cols-1 grid-cols-3 items-center justify-center gap-10 mx-20 md:mx-5">
        {careersData.map((career) => {
          return (
            <div>
              <div className="relative p-5 border-2 text-center rounded-tr-3xl rounded-bl-3xl border-black-500">
                {/* <img src={career.image} alt="career-img"  className='w-full h-52 text-center'/> */}

                <h1 className="text-xl font-semibold text-yellow-500  md:text-center py-0">
                  {" "}
                  <FaBullhorn
                    size={30}
                    color="green"
                    className="w-full text-center mt-10 animate-bounce"
                  />
                  {career.title}
                </h1>
                <hr className="py-2" />
                <div className="w-full h-52 text-justify text-center md:text-l  ">
                  <li>Experience:{career.jobexp}</li>
                  <li>Job Location:{career.location}</li>
                  <li>Roles:{career.description}</li>
                </div>

                <div className="absolute inset-0 flex items-center justify-center flex-col opacity-0 bg-black hover:opacity-80 rounded-tr-3xl rounded-bl-3xl">
                  <button className="border-2 rounded border-white py-2 hover:bg-green-900 px-5 mt-5 text-white">
                    APPLY NOW
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Layout>
  );
}

export default Careers;
